import { formatCurrency } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { MoneyHelper } from '@shared';
import { DEFAULT_DECIMAL_PLACES, fixedDigitsInfo } from '@shared/models/decimal-places';

/**
 * "1,234.50" — an amount painted with exactly `decimals` fraction digits (en-US grouping, no symbol).
 * Screens that follow the organisation's Decimal Places setting pass `DecimalPlacesService.current.amount`;
 * the rest keep the two decimals the pipe always painted.
 */
@Pipe({
  name: 'currencyFormatterV3'
})
export class CurrencyFormatterV3Pipe implements PipeTransform {

  locale = 'en-US';
  currencySymbol: string = '';
  currencyCode: string = '';

  constructor(private moneyHelper: MoneyHelper) { }

  transform(value: number, decimals: number = DEFAULT_DECIMAL_PLACES.amount) {
    return formatCurrency(
      this.moneyHelper.round(value, decimals),
      this.locale,
      this.currencySymbol,
      this.currencyCode,
      fixedDigitsInfo(decimals)
    ).trim();
  }

}
